import { render, staticRenderFns } from "./ContactsBlock.vue?vue&type=template&id=5c1a8696&"
import script from "./ContactsBlock.vue?vue&type=script&lang=js&"
export * from "./ContactsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ContactsBlock.vue?vue&type=style&index=0&id=5c1a8696&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports